/* @flow weak */

'use strict';

const React = require('react');
const _ = require('lodash');

const QuestionStore = require('../../stores/QuestionStore.jsx');
const PartStore = require('../../stores/PartStore.jsx');

const QuestionRenderer = React.createClass({
  propTypes: {
    question: React.PropTypes.object.isRequired,
    validationData: React.PropTypes.object.isRequired,
    hasUserSubmitted: React.PropTypes.bool,
    tabIndex: React.PropTypes.number.isRequired,
    isLast: React.PropTypes.bool
  },

  renderQuestion(question, validationData, hasUserSubmitted) {
    let parts = PartStore.fetchPartsForQuestion(question.id);
    let props = {
      question,
      parts,
      validationData,
      hasUserSubmitted,
      tabIndex: this.props.tabIndex,
      isChild: question.parent_id !== null
    };

    return React.createElement(
      require('./Question.jsx'),
      props
    );
  },

  render() {
    const { question, validationData, hasUserSubmitted, tabIndex, isLast } = this.props;
    const questionComponent = this.renderQuestion(question, validationData[question.id] || {}, hasUserSubmitted);
    const childQuestions = QuestionStore.getChildQuestions(question.id);
    var parentQuestionClasses = 'uc-parent-question-container';
    if (childQuestions.length > 0) {
      for (var i = 0; i < childQuestions.length; i++) {
        parentQuestionClasses = 'uc-parent-question-container uc-parent-has-no-active-child';
        if ((childQuestions[i].constraints == null && validationData[childQuestions[i].id] == null && childQuestions[i].control != 'SaveLink') 
            || (validationData[childQuestions[i].id] != null && validationData[childQuestions[i].id].visible != false)) 
        {
          parentQuestionClasses = 'uc-parent-question-container';
          break;
        }
      }
    }
    var classes = childQuestions.length > 0 ? parentQuestionClasses : 'uc-question-container';
    if (isLast) classes += ' uc-last-question-in-group';

    let childComponents;

    if (childQuestions.length > 0) {
      childComponents = (
        <div className="uc-question-children">
          {_.map(childQuestions, (q, i) =>
            <QuestionRenderer 
              key={q.id}
              question={q} 
              validationData={validationData}
              hasUserSubmitted={hasUserSubmitted}
              tabIndex={tabIndex + i + 1} />
          )}
        </div>
      );
    }

    return (
      <div className={classes}>
        {questionComponent}
        {childComponents}
      </div>
    );
  }
});

module.exports = QuestionRenderer;


// WEBPACK FOOTER //
// ./src/base/scripts/components/renderers/QuestionRenderer.jsx